import { Component, OnInit, Input, ViewChild, Renderer2 } from '@angular/core';
import { MatSort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';
import { MatMenuTrigger } from '@angular/material/menu';
import { MatTableDataSource } from '@angular/material/table';
import { TCCPCommonService } from '../../services/tccp-common.service';
import { TCCPLocalStorageService } from '../../services/tccp-local-storage.service';
import { ErrorGuides, MessageGuideRequest } from '../../models/error-guides';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmModalComponent } from '../confirm-modal/confirm-modal.component';
import { environment } from '../../../../environments/environment';
import { AdminService } from '../../../admin/admin.service';
import { TCCPConstantValues } from '../../../shared/models/tccp-constants';
import { LoaderService } from '../../loader/loader.service';
import { DatePipe } from '@angular/common';
import * as XLSX from 'xlsx';
import _ from 'lodash';

type AOA = any[][];
@Component({
  selector: 'app-error-guide-table',
  templateUrl: './error-guide-table.component.html',
  styleUrls: ['./error-guide-table.component.scss']
})
export class ErrorGuideTableComponent implements OnInit {
  public appName: string = null;
  public columns = [];
  public responsiveColumns = [];
  public isOpenSelect = false;
  public alerts: any[] = [];
  public excelBase64Content;
  public windowWidth = window.innerWidth;
  public messageGuideData = [];
  public messageAppName: string = null;
  constructor(
    public commonService: TCCPCommonService, private storageService: TCCPLocalStorageService, private router: Router,
    private dialog: MatDialog, private renderer: Renderer2, private adminService: AdminService, private datePipe: DatePipe,
    private loaderService: LoaderService) {
    this.displayedColumns = ['code',
      'feature', 'message.contentTMNA',
      'message.description', 'updatedBy', 'updatedAt', 'action'];
    this.columns = [{ name: 'code', value: 'Code' }, { name: 'feature', value: 'Feature' },
    { name: 'message.solution', value: 'Solution' },
    { name: 'message.effect', value: 'Effect' }, { name: 'message.contentTMNA', value: 'Content TMNA' },
    { name: 'message.description', value: 'Description' },
    { name: 'message.cause', value: 'Cause' }, { name: 'message.shortDescription', value: 'Short Description' },
    { name: 'message.diagnostic', value: 'Diagnostic' },
    { name: 'message.contentTCI', value: 'Content TCI' }];

    this.responsiveColumns = [{ name: 'code', value: 'Code' }, { name: 'feature', value: 'Feature' },
    { name: 'solution', value: 'Solution' },
    { name: 'effect', value: 'Effect' }, { name: 'contentTMNA', value: 'Content TMNA' },
    { name: 'description', value: 'Description' },
    { name: 'cause', value: 'Cause' }, { name: 'shortDescription', value: 'Short Description' },
    { name: 'diagnostic', value: 'Diagnostic' },
    { name: 'contentTCI', value: 'Content TCI' }];
  }
  @ViewChild(MatSort, { static: false }) sort: MatSort;
  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;
  @ViewChild(MatMenuTrigger, { static: false }) trigger: MatMenuTrigger;
  @ViewChild('errorSelect', { static: false }) errorSelect;

  public displayedColumns: string[] = [];
  public errorGuidesDataSource = new MatTableDataSource([]);
  public errorGuideOptions = [];
  public selectedPortal: any;
  public showAdd = false;
  public portalName: string;
  private excelData: any;

  ngOnInit() {
    this.appName = environment.applicationName;
    this.commonService.isMessageComponentOpened = true;
    this.messageAppName = this.adminService.selectedApplication;
    this.hideBackgroundImage();
    this.commonService.hideBreadrumb.emit(true);
    if (this.router.url.indexOf('admin') > -1) {
      this.showAdd = true;
      this.columns = this.columns.concat([{ name: 'tdPR_SP', value: 'tdPR_SP' }, { name: 'updatedBy', value: 'Updated By' },
      { name: 'updatedAt', value: 'Updated At' }, { name: 'action', value: 'Action' }]);
    }

    this.portalName = this.appName && this.appName === 'admin' ?
      this.adminService.selectedApplication.substring(0, 1).toUpperCase() +
      this.adminService.selectedApplication.substring(1).toLowerCase() : this.appName.substring(0, 1).toUpperCase() +
      this.appName.substring(1).toLowerCase();
    this.errorGuideOptions = [{ name: this.portalName + ' App', value: 'Mobile App', checked: true },
    { name: 'Dealer Portal', value: 'Dealer Portal', checked: false }];
    this.selectedPortal = this.errorGuideOptions[0].value;
    this.getAllErrorGuides(this.selectedPortal);
  }

  closeErrorGuide() {
    this.commonService.isMessageComponentOpened = false;
    this.commonService.showMessageGuide.emit(false);

  }

  hideBackgroundImage() {
    this.commonService.setBackground(this.renderer, this.appName);
  }

  ngDestroy() {
  }

  toggleColumnSelect() {
    this.isOpenSelect = !this.isOpenSelect;
    if (this.isOpenSelect) {
      this.errorSelect.open();
    } else {
      this.errorSelect.close();
    }
  }

  closeMyMenu() {
    this.trigger.closeMenu();
  }
  editErrorGuide(errorGuideObj: ErrorGuides) {
    this.router.navigateByUrl('/admin/add-message-guide', { state: { errorGuide: errorGuideObj } });
  }

  deleteErrorGuide(errorGuide: ErrorGuides) {
    this.openConfirmDialog(errorGuide);
  }

  onColumnChange() {
    if (this.router.url.indexOf('admin') > -1) {
      this.showAdd = true;
      this.displayedColumns.push('action');
    }
  }

  onPlatformChange(event) {
    this.getAllErrorGuides(event.value);
  }

  openConfirmDialog(errorGuide: ErrorGuides): void {
    const dialogRef = this.dialog.open(ConfirmModalComponent, {
      width: '350px',
      data: 'Are you sure you want to delete the message guide? '
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.commonService.deleteErrorGuide(errorGuide.platform, errorGuide.code).subscribe(data => {
          if (data) {
            this.selectedPortal = this.errorGuideOptions[0].value;
            this.getAllErrorGuides(this.selectedPortal);
          }
        });
      }
    });
  }

  applyFilter(filterValue: string) {
    this.errorGuidesDataSource.filter = filterValue.trim().toLowerCase();
  }

  getAllErrorGuides(platformObj?: string) {
    this.messageGuideData = [];
    this.commonService.getAllErrorMessages(platformObj).subscribe((response: any) => {
      const formattedJSON = JSON.parse(response);
      formattedJSON.filter(x => {
        const data = x;
        data['solution'] = x.message.solution;
        data['contentTCI'] = x.message.contentTCI;
        data['effect'] = x.message.effect;
        data['contentTMNA'] = x.message.contentTMNA;
        data['description'] = x.message.description;
        data['cause'] = x.message.cause;
        data['shortDescription'] = x.message.shortDescription;
        data['diagnostic'] = x.message.diagnostic;
        this.messageGuideData.push(data);
      });
      this.errorGuidesDataSource.data = formattedJSON;
      setTimeout(() => {
        this.errorGuidesDataSource.sortingDataAccessor = (item, property) => {
          switch (property) {
            case 'message.solution': return item.message.solution;
            case 'message.contentTCI': return item.message.contentTCI;
            case 'message.effect': return item.message.effect;
            case 'message.contentTMNA': return item.message.contentTMNA;
            case 'message.description': return item.message.description;
            case 'message.cause': return item.message.cause;
            case 'message.shortDescription': return item.message.shortDescription;
            case 'message.diagnostic': return item.message.diagnostic;
            default: return item[property];
          }
        };
        this.errorGuidesDataSource.sort = this.sort;
        this.errorGuidesDataSource.paginator = this.paginator;
      });

      this.errorGuidesDataSource.filterPredicate = (data: any, filter) => {
        const dataStr = JSON.stringify(data).toLowerCase();
        return dataStr.indexOf(filter) !== -1;
      };
    });
  }

  /* Upload message guide by Excel */
  uploadFiles() {
    const element: HTMLElement = document.getElementsByClassName('templateUploader')[0] as HTMLElement;
    element.click();
  }

  getBase64(file) {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      this.excelBase64Content = reader.result;
    };
    reader.onerror = (error) => {
    };
  }

  closeAlerts() {
    this.alerts = [];
  } 

  onFileChange(fileEvent, files: FileList) {
    const ext = files[0].name.split('.').pop();
    const filename = files[0].name.replace('.' + ext, new Date().getTime() + '.' + ext);
    const target: DataTransfer = <DataTransfer>(fileEvent.target);
    const reader: FileReader = new FileReader();
    this.getBase64(files[0]);
    const excelExtensionTypes = ['xlsx', 'xls'];
    const columns = ['Support_Code',
      'Message', 'TMNA_Content', 'Solution', 'Cause"', 'Effect'
      , 'Diagnostic', 'Error_Description', 'Error_Code'
      , 'Word_Tracks', 'Platform', 'Feature_Function'
      , 'Screen', 'Display', 'CTS_Published', 'Publication_Date'
      , 'Item Type', 'Path'];
    let isValid = false;
    if (excelExtensionTypes.indexOf(ext) === -1) {
      this.showAlertMessages('error', TCCPConstantValues.admin.messages.EXCEL_FILE_FORMAT_ERROR);
      isValid = false;
    } else {
      isValid = true;
    }
    if (isValid) {
      const reader1: FileReader = new FileReader();
      reader1.readAsBinaryString(target.files[0]);
      reader1.onloadend = (event: any) => {
        /* read workbook */
        const bstr: string = event.target.result;
        const wb: XLSX.WorkBook = XLSX.read(bstr, { type: 'binary' });

        /* grab first sheet */
        const wsname: string = wb.SheetNames[0];
        const ws: XLSX.WorkSheet = wb.Sheets[wsname];

        /* save data */
        this.excelData = <AOA>(XLSX.utils.sheet_to_json(ws, { header: 1 }));

        const columnExistence = columns.findIndex(x => this.excelData[0].indexOf(x) === -1);
        if (columnExistence > -1) {
          this.showAlertMessages('error', TCCPConstantValues.admin.messages.UPLOAD_EXCEL_FILE_ERROR);
        } else {
          if (!_.isEqual(columns, this.excelData[0])) {
            this.showAlertMessages('error', TCCPConstantValues.admin.messages.UPLOAD_EXCEL_FILE_ERROR);
            isValid = false;
          }
        }
      };
    }
    if (isValid) {
      reader.readAsBinaryString(target.files[0]);
      reader.onloadend = (event: any) => {
        if (files[0].name !== '') {
          const fileRequestBody: MessageGuideRequest = <MessageGuideRequest>{};
          fileRequestBody.source = this.adminService.selectedApplication;
          fileRequestBody.contentType = files[0].type;
          fileRequestBody.fileName = filename;
          fileRequestBody.contentBase64 = this.excelBase64Content;
          fileRequestBody.fileContent = this.excelData;
          fileRequestBody.upn = this.storageService.getUpn();
          this.loaderService.show();
          this.commonService.uploadMessageGuideTemplate(fileRequestBody, files[0].type).subscribe((response: any) => {
            if (response) {
              // this.commonService.getAllErrorMessages(this.selectedPortal).subscribe((getResponse: any) => {
              this.showAlertMessages('success', response.message);
              this.getAllErrorGuides(this.selectedPortal);
              // });
            }
            this.loaderService.hide();
          });
        }
      };
    }
  }

  public showAlertMessages(messageType, message) {
    this.alerts = [];
    if (this.alerts.length === 0) {
      this.alerts.push({
        type: messageType,
        msg: message
      });
    }
    window.scroll(0, 0);
  }
  public goBack() {
    window.history.back();
  }

}
